import { Table, Title } from 'rbx';
import React from 'react';
import { format } from 'date-fns';

/** The invoices issued for an add-on subscription's charges. */
function InvoicesTable({ invoices = [], showDomain }) {
  return (
    <>
      <Title subtitle size={5}>
        Invoices
      </Title>
      {!invoices.length ? (
        <p>No invoices</p>
      ) : (
        <Table fullwidth striped hoverable>
          <Table.Head>
            <Table.Row>
              <th>Invoice No</th>
              {showDomain && <th>Domain</th>}
              <th>Order ID</th>
              <th>Plan</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>Date</th>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {invoices.map(invoice => (
              <Table.Row key={invoice.invoiceNo}>
                <Table.Cell>{invoice.invoiceNo}</Table.Cell>
                {showDomain && (
                  <Table.Cell>{invoice.olaDomain || '-'}</Table.Cell>
                )}
                <Table.Cell>{invoice.orderId || '-'}</Table.Cell>
                <Table.Cell>{invoice.planId || '-'}</Table.Cell>
                <Table.Cell>{invoice.amount}</Table.Cell>
                <Table.Cell>{invoice.currency}</Table.Cell>
                <Table.Cell>
                  {invoice.createdAt
                    ? format(new Date(invoice.createdAt), 'do MMM yyyy')
                    : '-'}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </>
  );
}

export default InvoicesTable;
